export const formatBytes = (kilobytes: number, decimals = 2) => {
	if (kilobytes === 0) return '0 KB';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.floor(Math.log(kilobytes) / Math.log(k));

	return parseFloat((kilobytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
